import React from 'react';

/**
 * A component for consistent section titles across the application
 * @param {Object} props - Component props
 * @param {string} props.title - The main title text
 * @param {string} props.subtitle - Optional subtitle text
 * @param {boolean} props.centered - Whether the title should be centered
 * @param {string} props.className - Additional CSS classes
 */
const SectionTitle = ({ 
  title, 
  subtitle, 
  centered = false, 
  className = '' 
}) => {
  return (
    <div className={`section-title ${centered ? 'text-center' : ''} ${className}`}>
      <h2 className="mb-2 animate-fade-in">{title}</h2>
      {subtitle && (
        <p className="text-muted mb-4 animate-fade-in-up delay-100">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionTitle;
